/**
 * Number of Side repeating group instances.
 * tag: 552
 * @readonly
 * @enum {number} (NumInGroup)
 */
export enum NoSides {
  /** One Side */
  OneSide = 1,
  /** Both Sides */
  BothSides = 2,
}
